export default () => ({
  list: [],
  requestStatus: {
    0: '未送付',
    1: '送付済',
    2: '送付しない'
  }
})
